import validator from "validator";

export function validateInput(field) {
  const { value, name } = field.target;
  switch (name) {
    case "first_name":
      return !validator.isAlpha(value.replace(/\s/g, ""))
        ? "Please enter a valid name"
        : "";
    case "phone_number":
    case "chat_phone_number":
    case "alternate_phone":
      return value
        ? !validator.isNumeric(value) || value.length !== 10
          ? "Please enter a valid phone number"
          : ""
        : "";
    case "userAlternateEmail":
    case "email":
      return !validator.isEmail(value) ? "Please enter valid email" : "";
    case "alternate_email":
      return value
        ? !validator.isEmail(value)
          ? "Please enter valid email"
          : ""
        : "";
  }
}

export function validateDefault(defaultValues) {
  let errors = {};
  Object.entries(defaultValues).map(([name, value]) => {
    switch (name) {
      case "first_name":
        errors = !validator.isAlpha(value.replace(/\s/g, ""))
          ? { ...errors, [name]: "Please enter a valid name" }
          : { ...errors, [name]: "" };
        break;
      case "phone_number":
      case "chat_phone_number":
      case "alternate_phone":
        if (value)
          errors =
            !validator.isNumeric(value.replace("+91", "")) ||
            value.replace("+91", "").length !== 10
              ? { ...errors, [name]: "Please enter a valid phone number" }
              : { ...errors, [name]: "" };
        break;
      case "email":
        if (value)
          errors = !validator.isEmail(value)
            ? { ...errors, [name]: "Please enter valid email" }
            : { ...errors, [name]: "" };
        break;
      case "alternate_email":
        if (value) {
          errors = !validator.isEmail(value)
            ? { ...errors, [name]: "Please enter valid email" }
            : { ...errors, [name]: "" };
        }
        break;
    }
  });
  return errors;
}
